export default __webpack_public_path__ + "static/cafe blackboard-1dbb6dd25f69b229626d2fc7b6f1416e.png";